/**
 * 车辆油耗实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-08
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    DatePicker,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';
const MODULENAME = '车辆油耗';
const CURRENTTIME = currentDate + ' 00:00:00'

const { TextArea } = Input;
const { Text } = Typography;

const MODULENAME_URL = CNF.navItems[1].submenu[2].url;

const Entity = (props) => {
    const { open, setOpen, record, refresh, carLists } = props;
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [carUlid, setCarUlid] = useState('');
    const [dealTime, setDealTime] = useState(CURRENTTIME);

    const [oilCardNumber, setOilCardNumber] = useState('');
    const [oilTypeNumber, setOilTypeNumber] = useState('');
    const [price, setPrice] = useState(0.00);
    const [quantity, setQuantity] = useState(0.00);
    const [amount, setAmount] = useState(0.00);
    const [oilAddress, setOilAddress] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setCarUlid('');
        setDealTime(CURRENTTIME);
        setOilCardNumber('');
        setOilTypeNumber('');
        setPrice(0.00);
        setQuantity(0.00);
        setAmount(0.00);
        setOilAddress('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (record) {
            setCarUlid(record.car_ulid);
            setDealTime(record.deal_time);
            setOilCardNumber(record.oil_card_number);
            setOilTypeNumber(record.oil_type_number);
            setPrice(record.price);
            setQuantity(record.quantity);
            setAmount(record.amount);
            setOilAddress(record.oil_address);
            setDescription(record.description);
        }
    }, [record]);

    const ok = () => {
        //  参数校验
        if (carUlid === '') {
            messageApi.error('车牌号码不能为空！');
            return;
        }
        // if (oilCardNumber === '') {
        //     messageApi.error('加油卡号不能为空！');
        //     return;
        // }
        if (oilTypeNumber === '') {
            messageApi.error('油品类型不能为空！');
            return;
        }
        if (!quantity) {
            messageApi.error('加油数量不能为零！');
            return;
        }

        setLoading(true);

        $.ajax({
            url: CNF.api + MODULENAME_URL.slice(1) + (record ? '/' + record.key : ''),
            headers: AddRequestHeaders(),
            type: record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                car_ulid: carUlid,
                deal_time: dealTime,
                oil_card_number: oilCardNumber || '',
                oil_type_number: oilTypeNumber,
                price: price,
                quantity: quantity,
                amount: amount,
                oil_address: oilAddress,
                description: description
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (err) {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };


    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={11}><Text>加油车辆</Text><Text type='danger'>*</Text></Col>
                        <Col span={12} offset={1}><Text>加油时间</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <Select
                                showSearch
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                value={carUlid || undefined}
                                onChange={(value) => setCarUlid(value)}
                                disabled={loading}
                                filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                options={carLists && carLists.map((item, index) => ({
                                    key: index,
                                    value: item.key,
                                    label: item.license_number,
                                }))}
                            />
                        </Col>
                        <Col span={12} offset={1}>
                            <DatePicker
                                showTime
                                placeholder='请选择'
                                onChange={(_, dateString) => setDealTime(dateString)}
                                value={dayjs(dealTime, 'YYYY-MM-DD hh:mm:ss')}
                                style={{ width: '100%' }}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>加油卡号</Text></Col>
                        <Col span={12} offset={1}><Text>油品类型</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <Input
                                placeholder='请输入'
                                value={oilCardNumber}
                                onChange={(e) => setOilCardNumber(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={12} offset={1}>
                            <Select
                                value={oilTypeNumber || undefined}
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                onChange={(value) => setOilTypeNumber(value)}
                                disabled={loading}
                                options={CNF.oilTypeNumbers && CNF.oilTypeNumbers.map((item, index) => ({
                                    key: index,
                                    value: item.value,
                                    label: item.key,
                                }))}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>实时单价</Text></Col>
                        <Col span={12} offset={1}><Text>加油数量</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <InputNumber
                                style={{ width: '100%' }}
                                suffix='元'
                                min={0}
                                step='0.01'
                                value={price}
                                onChange={(value) => {
                                    setPrice(value);
                                    setAmount(value * quantity);
                                }}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={12} offset={1}>
                            <InputNumber
                                style={{ width: '100%' }}
                                suffix='L'
                                min={0}
                                step='0.01'
                                value={quantity}
                                onChange={(value) => {
                                    setQuantity(value);
                                    setAmount(value * price);
                                }}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>加油金额</Text></Col>
                        <Col span={24}>
                            <InputNumber
                                style={{ width: '100%' }}
                                suffix='元'
                                min={0}
                                step='0.01'
                                value={amount}
                                onChange={(value) => setAmount(value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>加油地址</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                value={oilAddress}
                                onChange={(e) => setOilAddress(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>加油备注</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={(e) => setDescription(e.target.value)}
                                value={description}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity